import React, { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';

const languages = ['Python', 'JavaScript', 'C++', 'Java', 'C'];

export default function Mentor({ userId }) {
  const [problem, setProblem] = useState('');
  const [code, setCode] = useState('');
  const [language, setLanguage] = useState('Python');
  const [feedback, setFeedback] = useState('');
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');
  const [chatLoading, setChatLoading] = useState(false);

  const submitSolution = async () => {
    if (!problem || !code) return;
    setLoading(true);
    setFeedback('');
    try {
      const res = await axios.post('https://recallcode-backend.onrender.com/submit', {
        user_id: userId,
        problem,
        code,
        language,
      });
      setFeedback(res.data.feedback);
    } catch (e) {
      setFeedback('Something went wrong. Is the backend running?');
    }
    setLoading(false);
  };

  const sendChat = async () => {
    if (!chatInput.trim()) return;
    const userMsg = chatInput;
    setChatInput('');
    setMessages(prev => [...prev, { role: 'user', text: userMsg }]);
    setChatLoading(true);
    try {
      const res = await axios.post('https://recallcode-backend.onrender.com/chat', {
        user_id: userId,
        message: userMsg,
      });
      setMessages(prev => [...prev, { role: 'ai', text: res.data.reply }]);
    } catch (e) {
      setMessages(prev => [...prev, { role: 'ai', text: 'Backend not reachable.' }]);
    }
    setChatLoading(false);
  };

  return (
    <div>
      <motion.div
        className="glass-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <h2>📝 Submit Your Solution</h2>
        <p style={{ marginBottom: 16 }}>
          Paste your code — RecallCode remembers your mistakes and gets smarter each session.
        </p>

        <input
          placeholder="What problem are you solving? e.g. Two Sum"
          value={problem}
          onChange={e => setProblem(e.target.value)}
        />

        <select value={language} onChange={e => setLanguage(e.target.value)}>
          {languages.map(l => (
            <option key={l}>{l}</option>
          ))}
        </select>

        <textarea
          rows={8}
          placeholder="Paste your code here..."
          value={code}
          onChange={e => setCode(e.target.value)}
          style={{ fontFamily: 'monospace' }}
        />

        <button
          className="btn-primary"
          onClick={submitSolution}
          disabled={loading}
        >
          {loading ? '🔍 Analysing...' : '🚀 Get AI Feedback'}
        </button>

        {feedback && (
          <motion.div
            className="feedback-box"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {feedback}
          </motion.div>
        )}
      </motion.div>

      <motion.div
        className="glass-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <h2>💬 Ask Your Mentor</h2>
        <p style={{ marginBottom: 16 }}>
          Your mentor already knows your history — ask anything.
        </p>

        <div className="chat-messages">
          {messages.length === 0 && (
            <p style={{ color: '#999', fontSize: 13, textAlign: 'center', padding: 20 }}>
              Ask me anything — I remember your past sessions!
            </p>
          )}
          {messages.map((m, i) => (
            <div key={i} className={`chat-msg ${m.role}`}>
              {m.text}
            </div>
          ))}
          {chatLoading && <div className="loading">Mentor is thinking...</div>}
        </div>

        <div className="input-row">
          <textarea
            placeholder="Ask your mentor..."
            value={chatInput}
            onChange={e => setChatInput(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && !e.shiftKey && sendChat()}
          />
          <button className="btn-primary" onClick={sendChat}>
            Send
          </button>
        </div>
      </motion.div>
    </div>
  );
}